import { render } from "./GuillotineStandings.vue?vue&type=template&id=3ee8b520&scoped=true&bindings={}"
import script from "./GuillotineStandings.vue?vue&type=script&lang=ts"
export * from "./GuillotineStandings.vue?vue&type=script&lang=ts"

import "./GuillotineStandings.vue?vue&type=style&index=0&id=3ee8b520&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3ee8b520"

export default script